export default __webpack_public_path__ + "static/media/Image-8.ed676656.png";